module.exports = __webpack_public_path__ + "img/footer-6-at.d75272a3.png";